import React, {useEffect, useState, useRef} from 'react';
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import ParticlesFX from './shared/particlesFX';

function Start()
{
  const navigate = useNavigate();

  useEffect(()=>{
    document.querySelector('meta[name="theme-color"]').setAttribute('content',  '#000000');
  }, []);

  const handleContinue = e => {
    e.preventDefault();

    Cookies.remove("game_id");
    Cookies.remove("user_name");
    Cookies.remove("player_id");
    Cookies.remove("group_id");
  
    setTimeout(()=>{
      navigate("/app/game/intro/1" + window.location.search);
    }, 1000);

  };

  return (
    <div className="mobileContainer start-screen">
      <div className='hero'>
        <ParticlesFX />
        <a href='#' onClick={handleContinue} className='start-button'>
          <div className='button'></div>
          <div className='ring'>
            <div className='ring-background'></div>
          </div>
        </a>
        <div className='circle-background'>
          <div className='circle-container'>
            <div className='circle'></div>
          </div>
        </div>
        <div className='ornament-1'>
          <div className='ornament-container'>
            <div className='ornament-section-1'></div>
            <div className='ornament-section-2'></div>
          </div>
        </div>
        <div className='ornament-2'>
          <div className='ornament-container'>
          </div>
        </div>
      </div>
      <div className='footer'></div>
    </div>
  );
}

export default Start;